import type { ActionHandler } from './types';

export const connectCalendarHandler: ActionHandler = {
  getHref: () => '/meetings?connect=true',
  getFollowUp: () => ({
    title: 'Connect your calendar',
    message:
      'Connect a Google or Outlook calendar. Afternoon will sync your meetings automatically.',
  }),
  completionEvents: ['CALENDAR_CONNECTED'],
};
